import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import HomePageListContext from "../../context/home-page-list/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import HomePageListContextProvider from "../../context/home-page-list/provider";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import HomePageListTable from "../../components/home-page-list/home-page-list-table";
import HomePagListFilter from "../../components/home-page-list/home-page-list-filter";
import { addSearchToURL, getFiltersFromURL, getKeywordFromURL } from "../../utils/helpers/url";
import { debounce } from "lodash";
interface IProps {
  children?: React.ReactNode;
}

const HomePageList: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(getKeywordFromURL());

  const { actions, loading, query } = useContext(HomePageListContext);


  useEffect(() => {
    const filters = getFiltersFromURL();
    actions.setQuery({
      page: 1,
      perPage: 10,
      filters: filters,
      keyword: search
    });
  }, []);

  const debouncedSearch = debounce((value: string | undefined) => {
          addSearchToURL(value);
          actions.setSearch(value);
      }, 300);
  
      useEffect(() => {
          debouncedSearch(search);
          return () => {
              debouncedSearch.cancel();
          };
      }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("home_page_list")}
        subTitle={t("home_page_list_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/home-page-list/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_home_page_list")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="home-page-list-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete("keyword");
          Object.keys(getFiltersFromURL()).forEach((key) =>
            searchParams.delete(key)
          );
          navigate(`${location.pathname}`, { replace: true });
          actions.setQuery({
            page: 1,
            perPage: query?.perPage,
            keyword: undefined,
            filters: [],
          });
          const form = document.getElementById("home-page-list-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <HomePagListFilter></HomePagListFilter>
      </SearchFilterCard>

      <HomePageListTable />
    </div>
  );
};

const HomePageListPage = () => {
  return (
    // ContextProvider
    <HomePageListContextProvider>
      <HomePageList />
    </HomePageListContextProvider>
  );
};
export default HomePageListPage;
